export enum ImageFilterEnum {
    EPIC = 'Epic',
    NO_FILTER = 'NoFilter',
    SIMPLE_ALPHA = 'SimpleAlpha',
}
